import axios from "axios";
import "./index.css";

let load = 0;

const instanceZatca = axios.create({
  baseURL: "https://gw-fatoora.zatca.gov.sa/e-invoicing/developer-portal/",
});

instanceZatca.interceptors.request.use(
  (config) => {
    load++;
    document.body.classList.add("loading-indicator");

    const csr = sessionStorage.getItem("csr");

    // Ensure headers object exists
    // if (!config.headers) {
    //   config.headers = {};
    // }

    // if (csr) {
    //   config.headers["Authorization"] = `Bearer ${csr}`;
    // }

    config.headers["OTP"] = "123345"; // This is usually dynamic and short-lived — verify with ZATCA docs.
    config.headers["Accept-Version"] = "V2";
    config.headers["Content-Type"] = "application/json";
    config.headers["Accept"] = "application/json";

    return config;
  },
  (error) => {
    load--;
    if (load === 0) {
      document.body.classList.remove("loading-indicator");
    }
    return Promise.reject(error);
  }
);

// Response Interceptor
instanceZatca.interceptors.response.use(
  (response) => {
    load--;
    if (load === 0) {
      document.body.classList.remove("loading-indicator");
    }
    return response;
  },
  (error) => {
    load--;
    if (load === 0) {
      document.body.classList.remove("loading-indicator");
    }
    return Promise.reject(error);
  }
);

export default instanceZatca;
